<template>
    <dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
        <template v-slot:title>Пользователи отчета</template>
        <template v-slot:content>
            <v-list class='pa-0 ma-0' style = 'max-height: 350px; overflow: scroll;'>
                <user-report-create 
                    v-if = '!["R","W"].includes(report.mode_persons)' 
                    :postAction = 'getPersons' 
                    :report = 'report'
                ></user-report-create>
                <v-divider v-if = '!["R","W"].includes(report.mode_persons)'></v-divider>
                <template v-for = "(ud, ui) in users">
                    <v-list-item three-line link :key = "ud.uid" :id = "ud.uid" :disabled = 'ud.grant_name == "default"'>
                        <v-list-item-action v-if = '!["R","W"].includes(report.mode_persons)'>
                            <v-checkbox
                                off-icon = 'mdi-checkbox-blank-circle-outline'
                                on-icon = 'mdi-checkbox-marked-circle-outline'
                                v-model = "deletedUsers" 
                                :value = 'ud.uid' 
                                :disabled = 'ud.grant_name == "default"'
                            ></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content class = 'text-left'>
                            <v-list-item-title>{{ud.name}} {{ud.lastname}}</v-list-item-title>
                            <v-list-item-subtitle>{{ud.mode_name}} | {{ud.mode_description}}</v-list-item-subtitle>
                            <v-list-item-subtitle>Доступы действуют <b v-if = '!ud.expire_on'>бессрочно</b><b v-else> до {{formatTime(ud.expire_on)}}</b></v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action v-if='!["R", "W"].includes(report.mode_persons)' class = 'my-auto'>
                            <span><user-report-update :data = 'ud' :postAction = 'getPersons' :report = 'report'></user-report-update></span>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider :key = 'ui' v-if = 'ui + 1 != users.length'></v-divider>
                </template>
                <v-list-item link dense v-if = '!users.length'>
                    <v-list-item-content>
                    	<v-list-item-title class="align-center">Пользователи не назначены</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </template>
        <template v-slot:action>
			<v-btn 
                v-if = '!["R","W"].includes(report.mode_persons)' 
                class = 'red--text text--darken-2'
                :loading = 'indicatorSecondary' 
                block depressed @click = 'deletePersons' 
                :disabled = 'deletedUsers.length == 0'
            >
                Удалить
            </v-btn>
		</template>
    </dialog-generic>
</template>
<script>

    import UserReportUpdate from '@/components/entities/users/reports/UpdateMenu.vue'
    import UserReportCreate from '@/components/entities/users/reports/CreateDialog.vue'
    import DialogGeneric from '@/components/elements/dialogs/Generic.vue'
    import dayjs from 'dayjs'

    export default {
        name: 'UsersReportController',
        props: ['report', 'initialState'],
        components: {
            'user-report-update': UserReportUpdate,
            'user-report-create': UserReportCreate,
            'dialog-generic': DialogGeneric
        },
        data() {
            return {
                visibility: this.initialState,
                indicator: false,
                indicatorSecondary: false,
                users: [],
                deletedUsers: []
            }
        },
        watch: {
            initialState(value) {
                this.visibility = value;
            },
            visibility(value) {
                this.$emit('update:initialState', value);
                if (value) {
                    this.getPersons()
                }
            },
            report() {
                this.getPersons()
            }
        },
        methods: {
            formatTime(time) {
                return dayjs(time).format('D MMM YYYY')
            },
            getPersons() {
                if (!Object.keys(this.report).length) return
                this.indicator = true;
                let params = {
                    'login': this.$store.getters.userLogin, 
                    'report_id': [this.report.report_id]
                }
                if (!this.report.is_client) {
                    params['segment'] = [this.report.segment_id]
                    params['vertical'] = [this.report.vertical_id]
                    params['project_name'] = [this.report.project_name]
                }
                this.$http.get(this.$store.getters.endpoint + '/db/reports/persons', {
                    emulateJSON: true,
                    params: params,
                    headers: this.$store.state.restrictedHeaders
                }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.users = response.data;
                        this.indicator = false;
                    } else {
                        console.log(response)
                    }
                })
            },
            deletePersons() {
                this.indicatorSecondary = true;
                this.$http.patch(this.$store.getters.endpoint + '/db/reports/persons', {
                'login': this.$store.getters.userLogin,
                'uid': this.deletedUsers,
                'report_id': this.report.report_id
                }, {
                headers: this.$store.state.restrictedHeaders
                }).then( (r) => {
                    let response = r.body;
                    if (response.result) {
                        this.$dataLayer.$emit('enrich', {
                        event: 'crud',
                            data: {
                                type: 'delete',
                                target: 'report_person'
                            },
                            once: false
                        })
                        this.indicatorSecondary = false;
                        this.getPersons();
                    }
            })
            }
        },
        mounted() {
            this.getPersons()
        }
    }
</script>